module.exports = __webpack_public_path__ + "img/55.fae243ee.jpg";